import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import theme from "../../../theme";

function AboutUsWelcomeComponent() {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      sx={{
        width: "100%",
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        gap: isMobile ? "28px" : "40px",
        height: "auto",
        marginBottom: "90px",
        padding: isMobile ? "22px 16px" : "40px 36px",
        background:
          "linear-gradient(180deg, rgba(255,249,238,1) 0%, rgba(255,255,255,1) 55%, rgba(246,247,249,1) 100%)",
        borderRadius: "24px",
        border: "1px solid rgba(20, 20, 20, 0.08)",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1.1fr 0.9fr",
          gap: isMobile ? "22px" : "32px",
        }}
      >
        <Box
          sx={{
            padding: isMobile ? "16px" : "24px",
            borderRadius: "18px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0 16px 40px rgba(15, 15, 15, 0.08)",
          }}
        >
          <Typography
            variant="overline"
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 700,
              letterSpacing: "0.08em",
            }}
          >
            About Us
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              fontSize: isMobile ? "22px" : "30px",
              marginBottom: "14px",
              fontFamily: "'Playfair Display', 'Times New Roman', serif",
            }}
          >
            Mandalar-HW YGN Company
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: isMobile ? "13px" : "16px",
              lineHeight: 2,
              textAlign: "justify",
              color: theme.palette.text.secondary,
            }}
          >
            အိမ်ဆောက်ပစ္စည်း၊ ကုန်ပစ္စည်းနှင့် စက်ပစ္စည်း အမျိုးမျိုးကို
            တစ်နေရာတည်းတွင် ပစ္စည်းစုံစုံလင်လင် ရရှိနိုင်ပါသည်။
          </Typography>
          <Box sx={{ height: "12px" }} />
          <Typography
            variant="body1"
            sx={{
              fontSize: isMobile ? "13px" : "16px",
              lineHeight: 2,
              textAlign: "justify",
              color: theme.palette.text.secondary,
            }}
          >
            ရရှိနိုင်သော ပစ္စည်းအမျိုးအစားများမှာ
          </Typography>
          <Box
            sx={{
              marginTop: "8px",
              paddingLeft: "18px",
              color: theme.palette.text.secondary,
              "& li": {
                marginBottom: "6px",
                lineHeight: 1.8,
                fontSize: isMobile ? "13px" : "16px",
              },
            }}
            component="ol"
          >
            <li>ပန်းရံသုံး ပစ္စည်းအမျိုးမျိုး</li>
            <li>လက်သမားသုံး ပစ္စည်းအမျိုးမျိုး</li>
            <li>Workshop ပစ္စည်းအမျိုးမျိုး</li>
            <li>အိမ်ရိုက်သံ size စုံ</li>
            <li>သွပ်နန်းကြိုး size စုံ</li>
            <li>ဘလိတ်ဒါးဆူးကြိုး size စုံ</li>
            <li>မူလီ ၊ bolt nut အမျိုးမျိုး</li>
            <li>ဝရိန်ချောင်း ၊ သွပ်မိူ size စုံ</li>
            <li>Tools ပစ္စည်း အမျိုးမျိူး</li>
            <li>သံဖိနပ် ၊ သံကျင်တွယ်အမျိုးမျိုး</li>
            <li>သံဇကာ ၊ အုတ်ညစ်ဇကာ ၊ သစ်ခွဇကာ အမျိုးမျိူး</li>
            <li>ပေါက်ပြား ၊ ဂေါပြား ၊ ထွန်ဂျစ် အမျိုးမျိုး</li>
            <li>ကော်အမျိုးမျိုး</li>
            <li>သော့အမျိူးမျိူး ၊ ဓါးသွေးကျောက်အမျိုးမျိုး</li>
            <li>ပတ်တာ ၊ ချောက်မှဖိး ၊ မင်းတုန်း ၊ ဂလန့် ၊ လက်ဆွဲကွက် အမျိုးမျိုး</li>
          </Box>
          <Box sx={{ height: "12px" }} />
          <Typography
            variant="body1"
            sx={{
              fontSize: isMobile ? "13px" : "16px",
              lineHeight: 2,
              textAlign: "justify",
              color: theme.palette.text.secondary,
            }}
          >
            စသည်တို့နှင့် အခြားဆောက်လုပ်ရေးသုံးအမျိုးမျိုးတို့ကို တစ်နေရာတည်းတွင်
            ပစ္စည်းမှန် ဈေးမှန်ဖြင့် လက်လီလက်ကား ရောင်းချပေးလျက်ရှိပါသည်။
          </Typography>
        </Box>

        <Box sx={{ display: "grid", gap: "18px" }}>
          <Box
            sx={{
              padding: isMobile ? "16px" : "20px",
              borderRadius: "18px",
              backgroundColor: "#111827",
              color: "#F9FAFB",
            }}
          >
            <Typography
              variant="overline"
              sx={{ color: "#FBBF24", fontWeight: 700, letterSpacing: "0.08em" }}
            >
              Profile
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                fontSize: isMobile ? "18px" : "22px",
                marginTop: "6px",
                marginBottom: "10px",
                fontFamily: "'Playfair Display', 'Times New Roman', serif",
              }}
            >
              Our Vision
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: isMobile ? "13px" : "14px", lineHeight: 1.9 }}
            >
              မြန်မာနိုင်ငံတစ်ဝှမ်းရှိ အိမ်ဆောက်ပစ္စည်း ဆိုင်တိုင်းသည်
              ကုန်မာပစ္စည်း ၊ စက်ပစ္စည်း ၊ တွင်ခုံသုံးပစ္စည်း ၊ Tools ပစ္စည်းအစုံတို့ကို
              လွယ်ကူလျှင်မြန်စွာဖြင့် အသက်သာဆုံး ၊ လက်ကားဈေးနူန်းများဖြင့်
              ယုံကြည်စိတ်ချစွာ ဝယ်ယူနိုင်ရန်။
            </Typography>
          </Box>

          <Box
            sx={{
              padding: isMobile ? "16px" : "20px",
              borderRadius: "18px",
              backgroundColor: "#FFFFFF",
              border: "1px solid rgba(17, 24, 39, 0.08)",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 700,
                fontSize: isMobile ? "15px" : "16px",
                marginBottom: "6px",
              }}
            >
              Our Mission
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: isMobile ? "13px" : "14px",
                lineHeight: 1.9,
                color: theme.palette.text.secondary,
              }}
            >
              မြန်မာတစ်နိုင်ငံလုံးရှိ အိမ်ဆောက်ပစ္စည်းဆိုင်တိုင်း နှစ်ပေါင်း 30 ကျော်တိုင်
              ယုံကြည်စိတ်ချစွာ တခဲနက် အားပေးလျက်ရှိရာ ထိုယုံကြည်မူကို
              နောင်နှစ်ပေါင်းများစွာ တိုင်အခိုင်အမာ ဆက်လက်တည်ဆောက်သွားရန် နှင့်
              ပစ္စည်းအရည်အသွေးပိုင်းနှင့် ဈေးနူန်းမှန်ကန်မူ အပိုင်းတို့ကို
              အထူးသတိထားပြီး အကောင်းဆုံးဝန်ဆောင် မူပေးနိုင်ရန်။
            </Typography>
          </Box>

          <Box
            sx={{
              padding: isMobile ? "16px" : "20px",
              borderRadius: "18px",
              backgroundColor: "#FFFFFF",
              border: "1px solid rgba(17, 24, 39, 0.08)",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 700,
                fontSize: isMobile ? "15px" : "16px",
                marginBottom: "6px",
              }}
            >
              Why Choose Us
            </Typography>
            <Box
              component="ul"
              sx={{
                margin: 0,
                paddingLeft: isMobile ? "18px" : "22px",
                display: "grid",
                gap: "8px",
                color: theme.palette.text.secondary,
                fontSize: isMobile ? "13px" : "14px",
                lineHeight: 1.8,
              }}
            >
              <Box component="li">
                ပစ္စည်းတိုင်းကို ပစ္စည်းမှန် ၊ ဈေးနူန်းဖြင့် ဖြန့်ဖြူးရောင်းချပေးလျှက်ရှိသည်။
              </Box>
              <Box component="li">
                China , India , ယိုးဒယားနိုင်ငံတို့မှ ပစ္စည်းများအားတိုက်ရိုက်
                တင်သွင်းပြီးရောင်းချပေးခြင်း။
              </Box>
              <Box component="li">
                အမှန်တကယ် နားလည်တတ်ကျွမ်းသော လုပ်သက်ရင့် 10 နှစ် 15 နှစ်အထက်ရှိ
                တာဝန်ခံဝန်ထမ်းများရဲ့ ဦးဆောင်မူအောက်တွင် လုပ်ငန်း လည်ပတ်ပြီး
                အကောင်းဆုံးဝန်ဆောင်မူများပေးခြင်း။
              </Box>
              <Box component="li">
                ပစ္စည်းတိုင်းကို အရေအတွက် များများ ၊ In stock ဖြစ်စေရန်
                တင်သွင်းထားပြီး Customer များ လိုသလောက်အရေအတွက် ရရှိစေရန်
                စနစ်တကျ စီမံဆောင်ရွက်ခြင်း ။
              </Box>
              <Box component="li">
                ပစ္စည်းများကို Customer များ ဖုန်းဆက်မှာယူသည်မှစ၍ အော်ဒါလက်ခံခြင်း ၊
                စနစ်တကျ ပစ္စည်း ပို့ပေးခြင်း ၊ သက်ဆိုင်ရာဆိုင်များ ၊ ကားဂိတ်များ ၊
                သင်္ဘောဆိပ်များ ၊ မီးရထားဂိတ်များ အထိ အရောက်ပို့ဆောင်ပေးပြီး
                Customer များ လက်ဝယ်ပစ္စည်း ရောက်သည်အထိ တာဝန်ယူမူ တာဝန်ခံမူအပြည့်ဖြင့်
                စနစ်တကျ အကောင်းဆုံးဝန်ဆောင် မူပေးလျက်ရှိခြင်း
              </Box>
              <Box component="li">
                Customer ကုန်သည်ကြီးများ၏ စာရင်းအင်းများ ၊ ငွေလွှဲများအားလုံးကို
                လုံခြုံမူနှင့် စနစ်တကျဖြစ်စေရန် ငှာနအသီးသီးထားရှိပြီး
                ကျွမ်းကျင်ဝန်ထမ်းများဖြင့် သေသေချာချာ စီမံ‌ဆောင်ရွက်ပေးလျှက်ရှိခြင်း ။
              </Box>
              <Box component="li">
                ဝယ်ယူပြီး ပစ္စည်း အချိန်မည်မျှကြာမြင့်သည်ဖြစ်စေ ၊ Error တစ်စုံတစ်ရာ
                ဖြစ်လာခဲ့လျှင် အကောင်းဆုံးပုံစံဖြင့် Customers များနစ်နာမူမရှိစေရန်
                တာဝန်ယူဖြေရှင်းပေးခြင်း။
              </Box>
              <Box component="li">
                ရန်ကုန် ၊ မြို့များအတွက် အရောက်ပို့ပေးပြီး အခြားနယ်မြို့များသို့လည်း
                သက်ဆိုင်ရာ ပစ္စည်းပို့ငှာနများသို့ အရောက်ပို့ဆောငိပေးခြင်း။
              </Box>
              <Box component="li">
                တစ်ဦးတည်း မူပိုင်အမှတ်တံဆိပ်များဖြစ်သော် Black Eagle , Aeroplane ,
                Fox Fox , SES , HiTec Ulite , UniPump , Silicare Smartcurt စသည့်
                အမှတ်တံဆိပ်များကို တရားဝင် Register လုပ်ပြီး မူပိုင်အမှတ်တံဆိပ်ဖြင့်
                တစ်နိုင်ငံလူံးရောင်းချပေးလျက်ရှိပါသည်။
              </Box>
              <Box component="li">
                စသည်အချက်များကြောင့် ပစ္စည်းမှန်ဈေးနူန်းမှန်ဖြင့် မြန်မာတစ်နိုင်ငံလုံးကို
                ဖြန့်ဖြူးရောင်းချပေးနေသော မန္တလေးသံဆိုင်ကို အပြည့်အဝယုံကြည်
                စိတ်ချစွာ ဝယ်ယူအားပေးနိုင်ပါပြီ။
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>

  )
}

export default AboutUsWelcomeComponent
